import { AxiosRequestConfig } from 'axios';
import api from './index';

const controllers = new Map<string, AbortController>();

function isFormData(value: unknown): value is FormData {
  return typeof FormData !== 'undefined' && value instanceof FormData;
}

function safeStringify(value: unknown) {
  if (value === undefined) return '';
  if (isFormData(value)) return 'FORM_DATA';

  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function getRequestKey(config: AxiosRequestConfig) {
  const {url = '', method = 'GET', params, data} = config;

  return `${method}:${url}:${safeStringify(params)}:${safeStringify(data)}`;
}

export async function request<T>(config: AxiosRequestConfig): Promise<T> {
  const key = getRequestKey(config);

  if (controllers.has(key)) {
    controllers.get(key)?.abort();
    controllers.delete(key);
  }

  const controller = new AbortController();
  controllers.set(key, controller);

  try {
    const response = await api.request<T>({
      ...config,
      signal: controller.signal,
    } as AxiosRequestConfig);

    return response.data;
  } finally {
    controllers.delete(key);
  }
}
